import { Navigate, useLocation, useParams } from "react-router";

import { buildResourcePath } from "~/routes";

// The legacy `/artifact/:artifactId/:artifactVersionId?` route rendered a deprecated page; the
// canonical artifact view is `/resources/artifact/:artifactId/:artifactRevisionId?` (see id-redirect.tsx).
// Links to the old path are still emitted by the notebook, document editor, and AI chat, so redirect
// them — preserving the pinned revision (the version id is the same identifier domain as the revision
// id) and any query/hash (line ranges, JSON paths, viewport, view state) so deep links keep working.
export function LegacyArtifactRedirect() {
  const { artifactId, artifactVersionId } = useParams();
  const { search, hash } = useLocation();
  const pathname = artifactId
    ? buildResourcePath({ artifactId, artifactRevisionId: artifactVersionId })
    : buildResourcePath();
  return <Navigate to={{ pathname, search, hash }} replace />;
}
